import type { ClipboardService } from '../clipboard.service'
import type * as models from '../models'

/** TODO:  */
export type Config<TItem extends models.Item<any>> = Required<
  Config.Options<TItem>
>

export namespace Config {
  /** TODO: Noting in here at the moment, but might be. */
  export function from<TItem extends models.Item<any>>(
    config: Config.Options<TItem>,
  ): Config<TItem> {
    return config
  }

  export interface Options<TItem extends models.Item<any>> {
    clipboardService: ClipboardService
    pasteClassRef: models.Item.Class<TItem>
  }
}
